import { render, staticRenderFns } from "./PricingPeriodForm.vue?vue&type=template&id=0ab6fc6e&scoped=true"
import script from "./PricingPeriodForm.vue?vue&type=script&lang=js"
export * from "./PricingPeriodForm.vue?vue&type=script&lang=js"
import style0 from "./PricingPeriodForm.vue?vue&type=style&index=0&id=0ab6fc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6fc6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VCheckbox,VDatePicker})
